import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {ExcSigninService} from 'exc-signin';
import {ExcCoreModule} from 'exc-core';
import {DashboardComponent} from './dashboard/dashboard.component';
import {OrderOpenComponent} from './order-open/order-open.component';
import {OrderFinishedComponent} from './order-finished/order-finished.component';
import {OrderCreateComponent} from './order-create/order-create.component';
import {PlanningHqComponent} from './planning-hq/planning-hq.component';
import {DealerListComponent} from './dealer-list/dealer-list.component';
import {PlanningHq2Component} from './planning-hq2/planning-hq2.component';
import {KanbanComponent} from './kanban/kanban.component';
import {ReviewListOpenComponent} from './review-list-open/review-list-open';
import {ReviewInboxComponent} from './review-inbox/review-inbox.component';
import {ClientConfigComponent} from './client-config/client-config.component';
import {AuditDispositionComponent} from './audit-disposition/audit-disposition.component';
import {ProviderAuditListComponent} from './provider/provider-audit-list/provider-audit-list.component';
import {ProviderDealerListComponent} from './provider/provider-dealer-list/provider-dealer-list.component';
import {MeComponent} from './common/me/me.component';
import {ProviderDashboardComponent} from './provider/provider-dashboard/provider-dashboard.component';
import {ProviderConfigComponent} from './provider/provider-config/provider-config.component';
import {ExconClientListComponent} from './excon/excon-client-list/excon-client-list.component';
import {AuditPlanningComponent} from './audit-planning/audit-planning.component';
import {ExconAuditListComponent} from './excon/excon-audit-list/excon-audit-list.component';
import {ExconDealerListComponent} from './excon/excon-dealer-list/excon-dealer-list.component';
import {CalendarComponent} from './client/calendar/calendar.component';
import {ReviewListDoneComponent} from './review-list-done/review-list-done';
import {AuditListPendingComponent} from './audit-list-pending/audit-list-pending';
import {DefaultSettingsService} from './default-settings-service.service';
import {PlanningHq2OverviewComponent} from './planning-hq2-overview/planning-hq2-overview.component';

@Injectable({providedIn: 'root'})
export class StateSecurityProcessor implements CanActivate {
  activeRouteName = '';

  constructor(private excSigninService: ExcSigninService, private router: Router, private excDss: DefaultSettingsService) {
    const _self = this;
    ExcCoreModule.on('ExcSignIn.RevalidateToken', function () {
        if (!_self.excSigninService.isStateAvailable(_self.activeRouteName)) {
          _self.router.navigate(['/']);
        }
      }
    );
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (route.data && route.data.security) {
      this.activeRouteName = route.routeConfig.path;
      if (!this.excSigninService.isStateAvailable(this.activeRouteName)) {
        this.router.navigate(['/']);
        return false;
      }
    }
    return true;
  }

}


const routes: Routes = [
  {path: '', redirectTo: 'me', pathMatch: 'full'},
  {
    path: 'me', component: MeComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-home', fn: 'Me'}
  },
  {
    path: 'cli/dashboard', component: DashboardComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-analytics', fn: 'Dashboard', security: 'CLI'}
  },
  {
    path: 'cli/calendar', component: CalendarComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-calendar-alt', fn: 'Dashboard', security: 'CLI'}
  },
  {
    path: 'prv/dashboard', component: ProviderDashboardComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-analytics', fn: 'Dashboard', security: 'PRV'}
  },
  {
    path: 'planninghq2', component: PlanningHq2Component, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-calendar-star', fn: 'Planung', security: 'CLI_PLAN_R'}
  },
  {
    path: 'planninghq2overview', component: PlanningHq2OverviewComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-calendar-week', fn: 'Planung', security: 'SFS_PLAN_R'}
  },
  // {
  //   path: 'auditplanning', component: AuditPlanningComponent, canActivate: [StateSecurityProcessor],
  //   data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-cart-arrow-down', fn: 'Beauftragung', security: 'CLI_PLAN_R'}
  // },
  {
    path: 'dispo', component: AuditDispositionComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-house-return', fn: 'Planung', security: 'PRV_DISP_R'}
  },
  {
    path: 'audits', component: ProviderAuditListComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-clipboard', fn: 'Audits', security: 'PRV_DISP_R'}
  },

  {
    path: 'dealer', component: DealerListComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-user', fn: 'Dealers', security: 'CLI_DLR_R'}
  },
  {
    path: 'providerdealer', component: ProviderDealerListComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-user', fn: 'ProviderDealers', security: 'PRV'}
  },
  {
    path: 'kanban', component: KanbanComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-mobile-alt', fn: 'Selfchecks', security: 'CLI_SC_R'}
  },
  {
    path: 'auditspending', component: AuditListPendingComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-file-search', fn: 'In Validierung', security: 'CLI_VER_R'}
  },
  {
    path: 'reviewopen', component: ReviewInboxComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-inbox', fn: 'Posteingang', security: 'CLI_REV_R'}
  },
  {
    path: 'review', component: ReviewListOpenComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-file-signature', fn: 'Laufende Auswertungen', security: 'CLI_REV_R'}
  },
  {
    path: 'reviewdone', component: ReviewListDoneComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-file-check', fn: 'Beendete Auswertungen', security: 'CLR_REVD_R'}
  },
  {
    path: 'ClientConfig', component: ClientConfigComponent, canActivate: [StateSecurityProcessor],
    data: {friendlyName: 'Konfiguration', class: 'far fa-fw  fa-tools', fn: 'Konfiguration', security: 'CLI_CFG_R'}
  },
  {
    path: 'ProviderClientConfig', component: ProviderConfigComponent, canActivate: [StateSecurityProcessor],
    data: {friendlyName: 'Konfiguration', class: 'far fa-fw  fa-tools', fn: 'Konfiguration', security: 'PRV'}
  },
  {
    path: 'exc/audits', component: ExconAuditListComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-clipboard', fn: 'Audits', security: 'EXC'}
  },
  {
    path: 'exc/dealers', component: ExconDealerListComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-car-garage', fn: 'Audits', security: 'EXC'}
  },
  {
    path: 'exc/config', component: ExconClientListComponent, canActivate: [StateSecurityProcessor],
    data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-university', fn: 'Mandanten', security: 'EXC'}
  }

  // {
  //   path: 'dashboard', component: DashboardComponent, canActivate: [StateSecurityProcessor],
  //   data: {get friendlyName() {return this.fn; }, class: 'far fa-fw fa-home', fn: 'Dashboard'}
  // },
  // {
  //   path: 'OpenOrders', component: OrderOpenComponent, canActivate: [StateSecurityProcessor],
  //   data: {get friendlyName() {return this.fn; }
  //     , class: 'far fa-fw fa-clipboard'
  //     , fn: 'In Bearbeitung'}
  // },
  // {
  //   path: 'FinishedOrders', component: OrderFinishedComponent, canActivate: [StateSecurityProcessor],
  //   data: { get friendlyName() {return this.fn; } , class: 'far fa-fw fa-clipboard-check', fn: 'Abgeschlossen'}
  // },
  //
  // {
  //   path: 'CreateOrder', component: OrderCreateComponent, canActivate: [StateSecurityProcessor],
  //   data: { get friendlyName() {return this.fn; } , class: 'far fa-fw fa-notes-medical', fn: 'PSA AT Auftrag anlegen'}
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
